import React, { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { MediaComponent, SearchInput } from 'components/index.js'
import { DragDropModal } from 'components/Modals'
import { updateSearchAction } from 'store/actions/header.action'
import ModalWrapper from 'components/Modals/ModalWrapper'
import { useRouter } from 'next/router'

const SelectMediaModal = ({ onClose, selectMedia }) => {
  const { t } = useTranslation('common')

  const dispatch = useDispatch()
  const router = useRouter()

  const user = useSelector((state) => state.auth.user)
  const [dragDropVisible, setDragDropVisible] = useState(false)
  const [search, setSearch] = useState('')

  let timeoutId
  useEffect(() => {
    if (timeoutId) clearTimeout(timeoutId)
    if (search) {
      timeoutId = setTimeout(() => {
        dispatch(updateSearchAction(search))
      }, 150)
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [search])

  const closeModal = () => {
    // Clear specific query parameters
    const query = { ...router.query }
    delete query.filter // Explicitly remove the filter key

    router.push(
      {
        pathname: router.pathname,
        query,
      },
      undefined,
      { shallow: true } // Avoid full page reload
    )

    onClose() // Trigger modal close logic
  }

  return (
    <ModalWrapper
      onClose={() => closeModal()}
      classNames="w-[94%] h-[96%] max-w-[1940px] gap-4 !justify-start md:!pt-4 !px-3 !py-2"
    >
      {dragDropVisible && <DragDropModal libraryModal={true} onClose={() => setDragDropVisible(false)} />}
      <div className="flex flex-col items-center justify-center px-1 !mt-0 gap-0 md:gap-4">
        <div className="self-stretch !w-full flex md:flex-row flex-col items-start md:justify-between">
          <div className="flex flex-row justify-around md:justify-between md:block w-full mb-2 md:mb-0 md:w-[33%]">
            <div className="text-[#101828] font-black text-base md:text-3xl w-[33%]">{t('common.library')}</div>
            {user && (
              <div
                className="flex gap-1 justify-center items-center mr-2 rounded-full border-gray-300 border-none cursor-pointer md:hidden md:border md:border-solid"
                onClick={() => setDragDropVisible(true)}
              >
                <span className="text-sm font-semibold">{t('common.upload')}</span>
                <img src={'/assets/common/upload-01.svg'} alt="upload" />
              </div>
            )}
          </div>

          <div className="right-section flex justify-between w-full md:w-[66%]">
            <div className="w-full md:w-3/5">
              <SearchInput
                placeholder={t('common.search-library')}
                style={{ padding: '7px 16px', width: '80.5%', height: 'auto' }}
                onChange={(e) => {
                  setSearch(e.target.value)
                }}
                value={search}
              />
            </div>
            {user && (
              <div
                className="cursor-pointer md:flex hidden md:gap-1 justify-center items-center px-4 py-[9px] mr-4 border border-solid border-gray-300 rounded-full "
                onClick={() => setDragDropVisible(true)}
              >
                <span className="text-sm font-semibold">{t('common.upload')}</span>
                <img src={'/assets/common/upload-01.svg'} alt="upload" />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="overflow-auto px-1 pr-3 md:px-0 media-upload-scrollbar">
        <MediaComponent
          onClickMedia={(media) => {
            selectMedia({ full_url: media })
            closeModal()
          }}
          defaultFilter={user ? 'My Results' : 'Trending'}
          filterClassNames={'items-center justify-start'}
          classNames={'!mt-0 pr-[30px]'}
        />
      </div>
    </ModalWrapper>
  )
}

export default SelectMediaModal
